import React, { useEffect, useState } from "react";
import { User, Film, FileText, LogOut, Briefcase } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { baseurl } from "../Baseurl";

function SellerSidebar() {
  const navigate = useNavigate();
  const [isApproved, setIsApproved] = useState(false);
  const sellerId = localStorage.getItem("seller_id"); 

  useEffect(() => {
    const fetchApproval = async () => {
      try {
        const response = await axios.get(`${baseurl}getSellerApprovalById/${sellerId}`);
        if (response.data.status === "success") {
          setIsApproved(response.data.approval);
        }
      } catch (error) {
        console.error("Error fetching approval:", error);
      }
    };

    if (sellerId) fetchApproval();
  }, [sellerId]);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to log out.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, log out",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("seller_id");
        localStorage.removeItem("seller_email");
        navigate("/seller/login");
      }
    });
  };

  return (
    <div className="sidebar-container">
      <div className="sidebar-links">
        <Link to="/seller/dashboard" className="sidebar-item">
          <User className="sidebar-icon" />
          <span className="sidebar-label">Dashboard</span>
        </Link>

        <Link to="/seller/my-inquiry" className="sidebar-item">
          <FileText className="sidebar-icon" />
          <span className="sidebar-label">My Inquiries</span>
        </Link>

        {/* <Link to="/seller/all-enquiry" className="sidebar-item">
          <FileText className="sidebar-icon" />
          <span className="sidebar-label">Product Enquiry</span>
        </Link> */}

        <Link to="/seller/my-orders" className="sidebar-item">
          <FileText className="sidebar-icon" />
          <span className="sidebar-label">My Order</span>
        </Link>

        <Link to="/seller/all-listing" className="sidebar-item">
          <Film className="sidebar-icon" />
          <span className="sidebar-label">My Listings</span>
        </Link>

        {/* Conditionally show Create Listing or Approval Pending */}
        {isApproved ? (
          <Link to="/seller/create-listing" className="sidebar-item">
            <Film className="sidebar-icon" />
            <span className="sidebar-label">Create Listings</span>
          </Link>
        ) : (
          <Link to="/seller/approval-pending" className="sidebar-item">
            <Film className="sidebar-icon" />
            <span className="sidebar-label">Create Listings</span>
          </Link>
        )}

        <Link to="/seller/bulk-upload" className="sidebar-item">
          <Film className="sidebar-icon" />
          <span className="sidebar-label">Bulk Upload </span>
        </Link>


        <Link to="/seller/service-team" className="sidebar-item">
          <Film className="sidebar-icon" />
          <span className="sidebar-label">Service Team</span>
        </Link>

        <Link to="/seller/profile" className="sidebar-item">
          <User className="sidebar-icon" />
          <span className="sidebar-label">My Account</span>
        </Link>

        <Link to="/seller/business-profile" className="sidebar-item">
          <Briefcase className="sidebar-icon" />
          <span className="sidebar-label">Business Profile</span>
        </Link>

        <Link to="/seller/change-password" className="sidebar-item">
          <Briefcase className="sidebar-icon" />
          <span className="sidebar-label">Change Password</span>
        </Link>

        <div className="sidebar-item" onClick={handleLogout}>
          <LogOut className="sidebar-icon" />
          <span className="sidebar-label">Logout</span>
        </div>
      </div>
    </div>
  );
}

export default SellerSidebar;
